export const SIDEBAR_RESET_STATE_KEY = "sidebarResetToDefaultView";
export const SIDEBAR_RESET_TARGET_KEY = "sidebarResetTargetPath";

export const createSidebarResetState = (targetPath) => ({
  [SIDEBAR_RESET_STATE_KEY]: Date.now(),
  [SIDEBAR_RESET_TARGET_KEY]: String(targetPath || ""),
});

export const navigateToSidebarPath = (navigate, location, targetPath, options = {}) => {
  const nextPath = String(targetPath || "");
  if (!nextPath || typeof navigate !== "function") return;

  const rawSearch = String(options?.search || "");
  const nextSearch = rawSearch
    ? rawSearch.startsWith("?")
      ? rawSearch
      : `?${rawSearch}`
    : "";
  const nextHash = String(options?.hash || "");

  navigate(
    {
      pathname: nextPath,
      search: nextSearch,
      hash: nextHash,
    },
    {
      replace:
        typeof options?.replace === "boolean"
          ? options.replace
          : String(location?.pathname || "") === nextPath &&
            String(location?.search || "") === nextSearch &&
            String(location?.hash || "") === nextHash,
      state: options?.state ?? createSidebarResetState(nextPath),
    }
  );
};

export const getSidebarResetToken = (location, targetPath) => {
  // A detail URL is newer than a reset flag carried forward in history state.
  // Reapplying that flag would send a profile back to its list during tab sync.
  const params = new URLSearchParams(location?.search || "");
  if (["companyId", "candidateId", "jobId", "leadId"].some(key => params.get(key))) return "";
  const state = location?.state;
  const resetTarget = String(state?.[SIDEBAR_RESET_TARGET_KEY] || "");
  const resetToken = state?.[SIDEBAR_RESET_STATE_KEY];
  const normalizedTargetPath = String(targetPath || "");

  if (!normalizedTargetPath || resetTarget !== normalizedTargetPath) return "";
  if (!resetToken) return "";

  return String(resetToken);
};
